import { create } from 'zustand';

interface AuthUiState {
  openLoginModal: boolean;
  setOpenLoginModal: (open: boolean) => void;
}

export const useAuthStore = create<AuthUiState>((set) => ({
  openLoginModal: false,
  setOpenLoginModal: (open) => set({ openLoginModal: open }),
}));

export const setOpenLoginModal = (open: boolean) =>
  useAuthStore.getState().setOpenLoginModal(open);
